module.exports = __webpack_public_path__ + "static/img/image_home_01.23d79ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_home_01.png
// module id = uF/F
// module chunks = 10